// angular
//     .module("HeroPRO")
//     .controller("MakeChangesModalController", makeChangesModalController);

import './makeChangesModal.scss';

/* @ngInject */
export default function makeChangesModalController($scope, AddProductsFactory, PermissionsFactory, FRInformationFactory) {
    const vm = this;

    const defaultItem = {
        title: 'Choose One',
        templateUrl: '',
    };
    vm.selectedItem = defaultItem;

    const appInfo = FRInformationFactory.getAppInfo();
    vm.isMultiFr = appInfo.IsMultiFundingRequest;

    const openInAPLTemplateUrl = 'app/appDetail/makeChangesModal/makeChangesOpenAPL.html';
    const generateACATemplateUrl = 'app/appDetail/makeChangesModal/makeChangesGenerateACA.html';

    vm.makeChangesMenu = [
        {
            title: 'Changes in Financing',
            type: 'heading',
        },
        {
            title: 'Increase the Project Financing Amount',
            templateUrl: openInAPLTemplateUrl,
            type: 'item',
        },
        {
            title: 'Decrease the Project Financing Amount',
            templateUrl: openInAPLTemplateUrl,
            type: 'item',
        },
        {
            title: 'Increase the Maximum Approval Amount',
            templateUrl: 'app/appDetail/makeChangesModal/makeChangesNewFinDocs.html',
            type: 'item',
        },
        {
            title: 'Change the Financing Term',
            templateUrl: openInAPLTemplateUrl,
            type: 'item',
        },
        {
            title: 'Change Pre-payment Options',
            templateUrl: openInAPLTemplateUrl,
            type: 'item',
        },
        {
            type: 'divider',
        },
        {
            title: 'Changes in Products',
            type: 'heading',
        },
        {
            title: 'Change the Product Details',
            templateUrl: openInAPLTemplateUrl,
            type: 'item',
        },
        {
            title: 'Change the Product Type or Category',
            templateUrl: openInAPLTemplateUrl,
            type: 'item',
        },
        {
            title: 'Add or Remove Products',
            templateUrl: openInAPLTemplateUrl,
            type: 'item',
        },
        {
            type: 'divider',
        },
        {
            title: 'Other Changes',
            type: 'heading',
        },
        {
            title: 'Change the Contractor',
            templateUrl: generateACATemplateUrl, 
            type: 'item',
        },
        {
            title: 'Change Property Owner',
            templateUrl: generateACATemplateUrl,
            type: 'item',
        },
        {
            title: 'Fix a Clerical Error',
            templateUrl: generateACATemplateUrl, 
            type: 'item',
        },
    ];

    // if the user is not a solicitor 
    if (!PermissionsFactory.hasPermission('IsSolicitor')) {
        // exclude the Change Pre-payment Options
        // as part of the menu 
        vm.makeChangesMenu = vm.makeChangesMenu.filter(item => item.title !== "Change Pre-payment Options");
    }

    vm.menuItemClicked = function (item, $event) {
        if (item.type === 'item') {
            vm.selectedItem = item;
        } else {
            $event.preventDefault();
            $event.stopPropagation();
        }
    };

    vm.getTemplate = function () {
        return vm.selectedItem.templateUrl;
    };

    vm.closeModal = function () {
        $scope.$close();
    };

    vm.openAddProductsWebsite = function() {
        AddProductsFactory.openAddProductsWebsite();
    };

}


// WEBPACK FOOTER //
// ./src/app/appDetail/makeChangesModal/makeChangesModalController.js